import React, { createContext, useContext, useState } from "react";

const DefaultContext = createContext();

export const useDefaultContext = () => useContext(DefaultContext);

export const DefaultProvider = ({ children }) => {
  const[megaMenuDis, setMegaMenuDis] = useState(false)

  return (
    <DefaultContext.Provider value={{ megaMenuDis,setMegaMenuDis}}>
      {children}
    </DefaultContext.Provider>
  );
};